import "./index.css";
import CryptoCorrelationApp from "./CryptoCorrelationApp";

export function App() {
  return <CryptoCorrelationApp />;
}

export default App;
